
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/competency-assessment/sessions",
      function () {
        return require("private-next-pages/competency-assessment/sessions.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/competency-assessment/sessions"])
      });
    }
  